import React, { Component } from "react";
import "./Game.css";
import Bingo from "./Bingo";
import { getNumber, getReset } from "./api";
import io from "socket.io-client";

export default class Game extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numbers: [],
      display: "none",
    };
  }

  componentDidMount() {
    const socket = io("https://numbers.inspectron.ch/numbers"); 
    const socket2 = io('https://numbers.inspectron.ch/');


    // Function for the Number pop up when a number is hit
    const nrPop = () => {
      fetch("https://numbers.inspectron.ch/numbers")
        .then(result => result.json())
        .then(result => {
          console.log("gagaaay")
          this.setState({
            numbers: result.numbers,
            display: "block"
          });
          setTimeout(() => {
            this.setState({
              display: "none"
            });
          }, 2000);
        });
    };


    // Gets the numbers from the REST API and puts it in a State
    // fetch("https://numbers.inspectron.ch/numbers")
    //   .then(result => result.json())
    //   .then(result => {
    //     this.setState({
    //       numbers: result.numbers
    //     });
    //   })
    //   .then(() => {
    //     console.log("Triggerd numbers: " + this.state.numbers);
    //   });

    getNumber();
    getReset();


    socket2.on('number2', (data) => {
      setTimeout(() => {
        nrPop();
      }, 750)
  })

 

    // Popup when a number is drawn
    socket.emit("sendNums");
    socket.on("getNums" , (getNums) => {
      console.log(getNums)
      this.setState({numbers: getNums})
    });
  }

  render() {
    return (
      <div className="container">
        <p
          style={{
            display: this.state.display,
            position: "fixed",
            zIndex: "3000",
            fontSize: "50px",
            margin: "auto",
            position: "absolute",
            top: "250px",
            left: "-10px",
            bottom: "0",
            right: "0",
            textAlign: "center"
          }}
          onClick={() =>
            this.setState({
              display: "none"
            })
          }
        >
          {this.state.numbers.slice(-1)}
        </p>
        <img
          style={{
            display: this.state.display,
            position: "fixed",
            zIndex: "2100",
            marginLeft: "30px",
            margin: "auto",
            position: "absolute",
            top: "30px",
            left: "0",
            bottom: "0",
            right: "0"
          }}
          onClick={() =>
            this.setState({
              display: "none"
            })
          }
          src="/assets/boom.png"
          alt="boom"
        />
        <Bingo data={Array.from(Array(25).keys())} test={this.state.numbers} />
        <div
          className="test"
          style={{
            position: "fixed",
            display: this.state.display,
            width: "100%",
            height: "100%",
            top: "0",
            left: "0",
            right: "",
            bottom: "0",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: "10",
            cursor: "pointer"
          }}
          onClick={() =>
            this.setState({
              display: "none"
            })
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Game.jsx